import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";

const pathBase = `/auth/sign-up-tokens/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const signUpToken = {
  post: apiPathFunc(pathBase),
};
